import { render, staticRenderFns } from "./DisciplineSettings.vue?vue&type=template&id=380b0f78&"
import script from "./DisciplineSettings.vue?vue&type=script&lang=js&"
export * from "./DisciplineSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports